/**
 * Настройка Роутинга приложения
 */
import Vue from 'vue';
import VueRouter, { Route, RouteConfig, RouteRecord } from 'vue-router';
import Meta from 'vue-meta';
import routesError from '@/pages/ErrorsPages/NotFound/routes';
import routesAdmin from '@/pages/Administration/routes';
import routesViewing from '@/pages/Viewing/routes';
import routesAuth from '@/pages/Auth/routes';
import store from '@/store';

// регистрируем роутер и 
// расширение метаинформации (чтобы title и другую ифнормацию можно было задавать в компонентах)
Vue.use(VueRouter);
Vue.use(Meta);

// Создаем массив для настроек роутинга
// собираем роутинг всех разделов сайта и складываем воедино
let routes: Array<RouteConfig> = [];
routes = routes.concat(routesAuth).concat(routesAdmin).concat(routesViewing).concat(routesError);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

// настраиваем доступ к страницас со стороны клиента
router.beforeEach((to: Route, from: Route, next: any) => {
    // Доступ только по авторизации
    if (to.matched.some((record: RouteRecord) => record.meta.requiresAuth)) {
        const isAuthenticated = store.getters['auth/isAuthenticated'];
        if (!isAuthenticated) {
            next('/auth');
        } else {
            next();
        }
    } else {
        next();
    }
    // Доступ только для администратора
    if (to.matched.some((record: RouteRecord) => record.meta.requiresAdmin)) {
        const isAdmin = store.getters['auth/isAdmin'];
        if (!isAdmin) {
            next('/404');
        } else {
            next();
        }
    } else {
        next();
    }
    // Доступ только для неавторизированных
    if (to.matched.some((record: RouteRecord) => record.meta.forbiddenAuth)) {
        const isAuthenticated = store.getters['auth/isAuthenticated'];
        if (isAuthenticated) {
            next('/');
        } else {
            next();
        }
    } else {
        next();
    }
});

/**
 * Роутинг приложения
 */
export default router;
